import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  root: css`
    max-width: 1200px;
    margin: auto;
    padding: 0 24px;
  `,
  infoText: css`
    font-size: 14px;
  `,
  additionalPadding: css`
    padding-top: 2px;
  `,
  csvButtonContainer: css`
    min-width: 150px;
    display: flex;
    justify-content: flex-end;
  `,
  grayText: css`
    color: ${colors.gray30};
  `,
  statusFlexBox: css`
    display: flex;
    gap: 5px;
  `,
  buttonRowCss: (padding = '16px 0') => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: ${padding};
  `,
  weeklyInfoHeader: css`
    display: flex;
    justify-content: flex-end;
    padding-inline-end: '16px';
  `,
  na: css`
    color: ${colors.gray30};
  `,
  projectTitleContainer: css`
    display: flex;
    justify-content: flex-start;
  `,

  padLeft: (pad = '4px') => css`
    padding-inline-start: ${pad};
  `,
}
